import React, {Component} from 'react';
import {Input,Form} from "antd";
import moment from "moment";
import BaseComponent from "../../../../base/BaseComponent";

class ViewTaskTime extends BaseComponent {
    constructor(props) {
        super(props);
        this.state={
        }
    }
    componentDidMount() {

    }


    render() {
        let startTime = this.props.itemValue[0] ? moment(this.props.itemValue[0]).format('YYYY-MM-DD HH:mm') : '';
        let endTime= this.props.itemValue[1] ? moment(this.props.itemValue[1]).format('YYYY-MM-DD HH:mm') : '';
        return (
            <Form.Item label={this.props.label} labelCol={{span: 3}} wrapperCol={{ span: 30 }} style={{display:"flex",alignItems: "center",width:'50%',marginBottom:'0 !important'}}>
                <div>{startTime&&endTime?(startTime+' ~ '+endTime):''}</div>
            </Form.Item>
        );
    }

}

export default ViewTaskTime